
$(function () {
    $('.js-form').map(function (i, item) {
        var form = new TurboForm(item, {
            fieldLineClass: 'field-wrap',
            errorClass: 'warning',
            showErrorAfterInput: true,
        });

        form.showSuccessMessage = function (message) {
            $('.success-message__text').html(message);
            $('.success-message-wrap').fadeIn(350).addClass('active');
        };

        form.afterSend = function () {
            if(window.yaCounter49950043) {
                yaCounter49950043.reachGoal('SUBMIT_FORM');
            }
        };

        form.showPreloader = function () {
            $('.js-preloader').show();
        };

        form.hidePreloader = function () {
            $('.js-preloader').removeAttr('style');
        }
    });
    window.onload = function() {
        $('.js-input-trace').each(function(index, item) {
            if (typeof b24Tracker === 'undefined') return
            const trace = b24Tracker.guest.getTrace()
            $(item).val(trace)
        })
    }
    window.rm = {};
    window.rm.main = {

        maxRound: 12,
        maxRound2: 16,
        maxRound3: 14,
        maxRound4: 10,

        init: function () {

            var _th = this,
                scrolling = true,
                $body = $('body');

            this.closeMenu = function () {

                if ($body.hasClass('open-menu')) {
                    $('.js-burger').toggleClass('open');
                    $body.toggleClass('open-menu');
                    $('.section-head-right').fadeToggle(350);
                }
            };

            $('.js-close-remodal').on('click', function () {
                $(this).closest('.remodal').remodal().close();
            });

            //выцепляем яблоки, вешаем класс
            if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
                var iHeight = $(window).height();
                $body.addClass('ios');
                if (navigator.userAgent.match(/(iPhone)/) && iHeight > 736) {
                    $body.addClass('ios_iPhoneX');
                } else {
                    $body.removeClass('ios_iPhoneX');
                }
                $('.js-select').addClass('default-select');
            } else {
                $('.js-select').removeClass('default-select');
                $('.js-filter-select[name="district[]"]').SumoSelect({
                    captionFormat: 'Районы +{0}',
                    captionFormatAllSelected: 'Район',
                    nativeOnDevice: ['Android', 'BlackBerry', 'iPhone', 'iPad', 'iPod', 'Opera Mini', 'IEMobile', 'Silk'],
                    okCancelInMulti: true,
                    placeholder: 'Район',
                    csvDispCount: 1,
                    locale: ['Применить', 'Cancel', 'Выберите']
                });
                $('.js-filter-select[name="collection[]"]').SumoSelect({
                    captionFormat: 'Расположение +{0}',
                    captionFormatAllSelected: 'Расположение',
                    nativeOnDevice: ['Android', 'BlackBerry', 'iPhone', 'iPad', 'iPod', 'Opera Mini', 'IEMobile', 'Silk'],
                    okCancelInMulti: true,
                    csvDispCount: 1,
                    placeholder: 'Расположение',
                    locale: ['Применить', 'Cancel', 'Выберите']
                });
                $('.js-filter-select[name="type[]"]').SumoSelect({
                    captionFormat: 'Формат +{0}',
                    captionFormatAllSelected: 'Формат',
                    nativeOnDevice: ['Android', 'BlackBerry', 'iPhone', 'iPad', 'iPod', 'Opera Mini', 'IEMobile', 'Silk'],
                    okCancelInMulti: true,
                    placeholder: 'Формат',
                    csvDispCount: 1,
                    locale: ['Применить', 'Cancel', 'Выберите']
                });

            }

            $('select.js-filter-select').on('change', function (e) {
                window.rm.location.filterSelectChange(e, $(this).attr('name'));
            });

            $('.js-filter-input').on('change', function (e) {
                window.rm.location.filterInputChange(e, $(this).attr('name'));
            });

            const $burger = $('.js-burger');
            if ($burger.length) {
                $burger.on('click', function () {
                    $(this).toggleClass('open');
                    $body.toggleClass('open-menu');
                    $('.section-head-right').fadeToggle(350);
                    return false;
                });
            }

            if ($('.js-scroll-to').length) {
                var btnAnchor = $('.js-scroll-to [data-anchor]');
                btnAnchor.on('click', function () {
                    scrolling = false;

                    var anchorItem = $('section[data-anchor-item="' + $(this).data('anchor') + '"]').offset().top;
                    window.rm.main.closeMenu();
                    $("html, body").animate({scrollTop: anchorItem}, 800, function () {
                        scrolling = true;
                    });
                    return false;
                });
            }

            if ($('.js-scroll').length) {
                var btnScroll = $('.js-scroll[data-anchor]');
                btnScroll.on('click', function () {
                    scrolling = false;

                    var anchorItem = $('section[data-anchor-item="' + $(this).data('anchor') + '"]').offset().top;
                    window.rm.main.closeMenu();
                    if ($(window).width() <= 480) {
                        $(this).parents('.object-card').removeClass('card-fixed show');
                        $('body').removeClass('card-open');
                        $('.address__item.active').removeClass('active');
                    }
                    $("html, body").animate({scrollTop: anchorItem}, 800, function () {
                        scrolling = true;
                    });
                    return false;
                });

            }

            const $btnScroll = $('.btn-scroll');
            if ($btnScroll.length) {
                $btnScroll.on('click', function () {
                    scrolling = false;

                    $("html, body").animate({scrollTop: $('.main')[0].offsetTop}, 800, function () {
                        scrolling = true;
                    });
                    return false;
                });
            }

            if ($('.partners-list').length) {
                setTimeout(function () {
                    $('.partners-list').mCustomScrollbar({
                        theme: "dark",
                        axis: "x",
                        horizontalScroll: false,
                        live: "on",
                        documentTouchScroll: true,
                        mouseWheel: {axis: "x"},
                        advanced: {
                            updateOnBrowserResize: true,
                            autoScrollOnFocus: true,
                        }
                    });
                }, 100);
            }

            const offerOwlcar = $('.js-offer-owlcar');
            if (offerOwlcar.length && offerOwlcar.find('.offer-owlitem').length > 1) {
                offerOwlcar.addClass('owl-carousel').owlCarousel({
                    loop: true,
                    nav: false,
                    center: true,
                    margin: 0,
                    responsive: {
                        0: {
                            items: 1
                        },
                        768: {
                            items: 2
                        },
                        1025: {
                            items: 3
                        }
                    }
                }).on('click', '.offer-owlitem', function (e) {
                    e.preventDefault();
                    if ($(e.target).parents('.owl-item:not(.center)').length) {
                        var clickElIndex = $(e.target).parents('.owl-item').index(),
                            centerElIndex = $('.offer-owlitem').parents('.owl-item.center').index();

                        $(e.target).parents('.offer-owlitem').addClass('block-hover');

                        if (centerElIndex > clickElIndex) {
                            offerOwlcar.trigger('prev.owl.carousel', [700]);
                            return false;
                        } else {
                            offerOwlcar.trigger('next.owl.carousel', [700]);
                            return false;
                        }
                    }
                });

                offerOwlcar.on('translated.owl.carousel', function (event) {
                    $('.offer-owlitem').removeClass('block-hover');
                });

            }

            const specOfferOwlcar = $('.js-srecoffer-owlcar');
            if (specOfferOwlcar.length && specOfferOwlcar.find('.specoffer-owlitem').length > 1) {
                specOfferOwlcar.addClass('owl-carousel').owlCarousel({
                    loop: true,
                    nav: false,
                    items: 1,
                    margin: 0,
                    animateIn: 'fadeIn',
                    animateOut: 'fadeOut',
                    mouseDrag: false
                });
                specOfferOwlcar.on('changed.owl.carousel', function () {
                    $('.js-srecoffer-owlcar .owl-dot').addClass('blocked');
                });
                specOfferOwlcar.on('translated.owl.carousel', function () {
                    $('.js-srecoffer-owlcar .owl-dot').removeClass('blocked');
                });
            }


            const prjOwlcar = $('.js-project-owlcar');
            var interval, owlActive;
            if (prjOwlcar.length && prjOwlcar.find('.project-owlitem').length > 1) {
                prjOwlcar.on('initialized.owl.carousel', function () {
                    owlActive = $(this).find('.owl-item.active');
                    clearInterval(interval);
                    interval = setInterval(function () {
                        const itemImgs = owlActive.find('.project-gallery-item__img'),
                            itemImgsVisible = owlActive.find('.project-gallery-item__img.visible');
                        if (itemImgsVisible.index() + 1 === itemImgs.length) {
                            itemImgsVisible.removeClass('visible');
                            itemImgs.eq(0).addClass('visible');
                        } else {
                            itemImgsVisible.removeClass('visible').next().addClass('visible');
                        }
                    }, 2000);
                });

                prjOwlcar.on('changed.owl.carousel', function () {
                    $('.js-project-owlcar .owl-dot').addClass('blocked');

                    $('.project-owlcar .review-item').fadeOut(0);
                    $('.project-owlcar').removeClass('hidden-dots');
                });

                prjOwlcar.addClass('owl-carousel').owlCarousel({
                    loop: true,
                    nav: false,
                    items: 1,
                    margin: 0,
                    animateIn: 'fadeIn',
                    animateOut: 'fadeOut',
                    smartSpeed: 750,
                    mouseDrag: false,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    autoplayHoverPause: true,
                    responsive: {
                        1024: {
                            autoHeight: true,
                            autoHeightClass: 'owl-height',
                        }
                    }
                });

                prjOwlcar.on('translated.owl.carousel', function () {
                    $('.js-project-owlcar .owl-dot').removeClass('blocked');
                    owlActive = $(this).find('.owl-item.active');
                    if (owlActive.length === 0) return;
                    clearInterval(interval);
                    interval = setInterval(function () {
                        const itemImgs = owlActive.find('.project-gallery-item__img'),
                            itemImgsVisible = owlActive.find('.project-gallery-item__img.visible');
                        if (itemImgsVisible.index() + 1 === itemImgs.length) {
                            itemImgsVisible.removeClass('visible');
                            itemImgs.eq(0).addClass('visible');
                        } else {
                            itemImgsVisible.removeClass('visible').next().addClass('visible');
                        }
                    }, 2000);
                });
            } else {
                if (prjOwlcar.find('.project-owlitem').length < 2 && $('.project-gallery-item__img').length > 1) {
                    clearInterval(interval);
                    interval = setInterval(function () {
                        var itemImgs = $('.project-gallery-item__img'),
                            itemImgsVisible = $('.project-gallery-item__img.visible');
                        if (itemImgsVisible.index() + 1 === itemImgs.length) {
                            itemImgsVisible.removeClass('visible');
                            itemImgs.eq(0).addClass('visible');
                        } else {
                            itemImgsVisible.removeClass('visible').next().addClass('visible');
                        }
                    }, 2000);
                }
            }

            // скрываем блок спец предложений если в нем нет активных элементов
            var hasSpec = false;
            $('.specoffer-owlcar').map(function (i, item) {
                if ($(item).attr('style') !== 'display:none') {
                    hasSpec = true;
                }
            });
            if (!hasSpec) {
                $('.specoffer-wrap').hide();
            }

            const actionPar = $('.js-action-location');
            if (actionPar.length) {
                const tabBt = actionPar.find('.location-tab-nav__btn'),
                    addressSpec = actionPar.find('.address__item');

                tabBt.on('click', function () {
                    const _t = $(this),
                        _tData = _t.data('tab-nav'),
                        tabItem = _t.parents('.location-content').find('.location-tabs-item');

                    if (!_t.hasClass('active')) {
                        tabBt.removeClass('active');
                        tabItem.removeClass('active');
                        _t.addClass('active');

                        if (_tData === 'map') {
                            $('.object-card.show').removeClass('show');
                        }

                        $('.location-content .location-tabs-item[data-tab-item="' + _tData + '"]').addClass('active');
                    }

                    return false;
                });

                addressSpec.on('click', function (e) {
                    return window.rm.location.addressEventHandler(e, this);
                });

                $(document).on('click', '.object-btn__close', function () {
                    $(this).parents('.object-card').removeClass('show');
                    $('body').removeClass('card-open');
                    $('.address__item.active').removeClass('active');
                    return false;
                })

            }

            const btnShowRev = $('.js-show-review');
            if (btnShowRev.length) {
                btnShowRev.on('click', function () {
                    const _t = $(this);

                    _t.siblings('.review-item').fadeToggle(350);
                    // $('.project-owlcar .owl-item.active .review-item').fadeToggle(350);
                    _t.parents('.project-owlcar').addClass('hidden-dots');

                    return false;
                })

            }

            const btnHideRev = $('.review-item__btn-close');
            if (btnHideRev.length) {
                btnHideRev.on('click', function () {
                    const _t = $(this);

                    _t.parent('.review-item').fadeToggle(350);
                    _t.parents('.project-owlcar').removeClass('hidden-dots');

                    return false;
                })

            }

            $('.form .field-wrap__input, .form .field-wrap__textarea').on('change', function () {
                const $this = $(this);
                if ($this.val().trim() !== '') {
                    $this.addClass('no-empty');
                } else {
                    $this.removeClass('no-empty');
                }
            });

            $(document).on({
                mouseenter: function () {
                    const _t = $(this),
                        _tIndex = _t.index(),
                        _tPar = _t.parents('.SumoSelect');
                    if (_tPar.find('.js-select').length) {
                        const option = _tPar.find('.js-select option');
                        option.each(function () {
                            if ($(this).index() === _tIndex) {
                                const wrapId = $(this).closest('.js-select').data('wrap-id')
                                $('.select-info-wrap[data-opt-id="' + $(this).data('opt-id') + '"][data-wrap-id="' + wrapId + '"]').fadeIn(0);
                            }
                        });
                    }
                },
                mouseleave: function () {
                    const _t = $(this),
                        _tPar = _t.parents('.SumoSelect');
                    if (_tPar.find('.js-select').length) {
                        $('.select-info-wrap').fadeOut(0);
                    }
                }
            }, 'li.opt');

            const decorPar = $('.decor');
            if (decorPar.length && $(window).width() > 1024) {
                // left

                const decorImg_1 = decorPar.find('.decor__elem_v2'),
                    decorImg_1Left = parseInt(decorImg_1.css('left')),
                    decorImg_1Bot = parseInt(decorImg_1.css('bottom')),

                    decorImg_3 = decorPar.find('.decor__elem_v4'),
                    decorImg_3Left = parseInt(decorImg_3.css('left')),
                    decorImg_3Top = parseInt(decorImg_3.css('top')),

                    // right

                    decorImg_2 = decorPar.find('.decor__elem_v1'),
                    decorImg_2Right = parseInt(decorImg_2.css('right')),
                    decorImg_2Top = parseInt(decorImg_2.css('top')),

                    decorImg_4 = decorPar.find('.decor__elem_v3'),
                    decorImg_4Right = parseInt(decorImg_4.css('right')),
                    decorImg_4Bot = parseInt(decorImg_4.css('bottom'));

                $body.mousemove(function (event) {
                    const centerX = Math.round($(window).width() / 2),
                        centerY = Math.round($(window).height() / 2),
                        diffX = -(event.clientX - centerX) / centerX,
                        diffY = -(event.clientY - centerY) / centerY;

                    // left

                    if (decorImg_1.length) {
                        TweenMax.to(decorImg_1, 2, {
                            'left': Math.round(decorImg_1Left - _th.maxRound * diffX * 2),
                            'bottom': Math.round(decorImg_1Bot - _th.maxRound * diffY * 2),
                            ease: Expo.easeOut
                        });
                    }

                    if (decorImg_3.length) {
                        TweenMax.to(decorImg_3, 2, {
                            'left': Math.round(decorImg_3Left - _th.maxRound3 * diffX * 2),
                            'top': Math.round(decorImg_3Top - _th.maxRound3 * diffY * 2),
                            ease: Expo.easeOut
                        });
                    }

                    // right

                    if (decorImg_2.length) {
                        TweenMax.to(decorImg_2, 2, {
                            'right': Math.round(decorImg_2Right - _th.maxRound2 * diffX * 2),
                            'top': Math.round(decorImg_2Top - _th.maxRound2 * diffY * 2),
                            ease: Expo.easeOut
                        });
                    }

                    if (decorImg_4.length) {
                        TweenMax.to(decorImg_4, 2, {
                            'right': Math.round(decorImg_4Right - _th.maxRound4 * diffX * 2),
                            'bottom': Math.round(decorImg_4Bot - _th.maxRound4 * diffY * 2),
                            ease: Expo.easeOut
                        });
                    }

                });
            } else {
                $('.decor__elem').each(function () {
                    $(this).removeAttr('style');
                });
            }

            $body.delegate('.js-offer-owlcar .owl-item:not(.center) .offer-owlitem', 'click', function () {
                return false;
            });

            $(document).on('mousedown', function (e) {
                const objectCard = $(e.target).closest(".js-object-card")
                const locationMap = $(e.target).closest(".js-map")
                const mapPreloader = $(e.target).closest(".js-map-preloader")

                if (!objectCard.length && !locationMap.length && !mapPreloader.length) {
                    $('.object-card.show').removeClass('show');
                    $('body').removeClass('card-open');
                    $('.address__item.active').removeClass('active');
                }

                e.stopPropagation();
            });

            function checkScrollBtn() {
                $(window).scroll(function (e) {
                    var wh = $(window).height(),
                        wst = $(window).scrollTop(),
                        btnScroll = $('.btn-scroll'),
                        ww = $(window).width();

                    if (ww < 992) {
                        if (wh + wst > wh + 105) {
                            btnScroll.stop(true, true).fadeOut(350);
                        } else {
                            btnScroll.stop(true, true).fadeIn(350);
                        }
                    }
                }).trigger('scroll');
            }

            function checkScrollMenu() {
                var lastScrollTop = 0,
                    burger = $('.burger.js-burger'),
                    secR = $('.section-head-right');

                $(window).scroll(function (e) {
                    var wh = $(window).height(),
                        wst = $(window).scrollTop(),
                        ww = $(window).width();

                    if (scrolling) {

                        if (wst > lastScrollTop && (wh + wst) > (wh + 105)) {
                            burger.stop(true, true).fadeOut(350);
                        } else {
                            if (ww > 991) {
                                burger.removeAttr('style');
                                secR.removeAttr('style');
                            } else {
                                burger.stop(true, true).fadeIn(350);
                            }
                        }

                        lastScrollTop = wst;
                    }

                }).trigger('scroll');
            }

            $(window).resize(function () {
                var wv = $(window).width();

                if (wv < 992) {
                    checkScrollBtn();
                    checkScrollMenu();
                } else {
                    $('.burger').removeAttr('style');
                    $('.section-head-right').removeAttr('style');
                    $('.btn-scroll').removeAttr('style');
                }

            }).trigger('resize');
        }

    };
    window.rm.cookie = {
        getCookie: function (name) {
            var matches = document.cookie.match(new RegExp(
                "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
            ));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },
        setCookie: function (name, value, options ) {
            if (!options) {
                options = {}
            }
            options = Object.assign({path: '/'}, options)

            if (options.expires instanceof Date) {
                options.expires = options.expires.toUTCString();
            }

            var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

            for (var optionKey in options) {
                updatedCookie += "; " + optionKey;
                var optionValue = options[optionKey];
                if (optionValue !== true) {
                    updatedCookie += "=" + optionValue;
                }
            }

            document.cookie = updatedCookie;
        }
    }
    window.rm.cookieNotification = {

        cookieElement: $('.js-cookie-notification'),
        cookieButtonElement: $('.js-cookie-notification-btn'),

        isCookieExist: function () {
            return rm.cookie.getCookie('cookie-confirm')
        },

        setCookie: function () {
            return rm.cookie.setCookie('cookie-confirm', '1')
        },

        init: function () {
            var _cookie = this
            if (!this.isCookieExist()) {
                setTimeout(function () {
                    _cookie.toggleCookie(true)
                }, 2000)
                this.createListener()
            }
        },

        createListener: function () {
            var _cookie = this
            this.cookieButtonElement.on('click', function () {
                _cookie.toggleCookie(false)
                _cookie.setCookie()
            })
        },

        toggleCookie: function (isShow) {
            this.cookieElement.toggle(isShow)
        }
    }

    window.rm.phoneAndEmailMask = {
        inputsPhone: $('.js-input-phone'),
        inputsEmail: $('.js-input-email'),

        init: function () {
            if (!this.inputsPhone.length && !this.inputsEmail.length) return


            this.inputsPhone.each(function (index, input) {
                IMask(input,  {
                    mask: '+{7} (000) 000-00-00'
                })
            })

            this.inputsEmail.each(function (index, input) {
                IMask(input, {
                    mask: /^\S*@?\S*$/
                })
            })
        },
    }
    window.rm.main.init();
    window.rm.cookieNotification.init();
    window.rm.phoneAndEmailMask.init();
});
